"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.transformWeekDaysObjectToArrayValues = void 0;
var transformWeekDaysObjectToArray = function (data) {
    var weekDays = [];
    var firstEntry = data[0] || null;
    if (firstEntry) {
        // eslint-disable-next-line no-restricted-syntax
        for (var _i = 0, _a = Object.entries(firstEntry); _i < _a.length; _i++) {
            var _b = _a[_i], key = _b[0], value = _b[1];
            if (key === 'monday' && value) {
                weekDays.push('Maandag');
            }
            if (key === 'tuesday' && value) {
                weekDays.push('Dinsdag');
            }
            if (key === 'wednesday' && value) {
                weekDays.push('Woensdag');
            }
            if (key === 'thursday' && value) {
                weekDays.push('Donderdag');
            }
            if (key === 'friday' && value) {
                weekDays.push('Vrijdag');
            }
        }
    }
    return weekDays;
};
exports.transformWeekDaysObjectToArrayValues = function (data) {
    var weekDays = [];
    var firstEntry = data[0] || null;
    if (firstEntry) {
        // eslint-disable-next-line no-restricted-syntax
        for (var _i = 0, _a = Object.entries(firstEntry); _i < _a.length; _i++) {
            var _b = _a[_i], key = _b[0], value = _b[1];
            if (key === 'monday' && value) {
                weekDays.push(key);
            }
            if (key === 'tuesday' && value) {
                weekDays.push(key);
            }
            if (key === 'wednesday' && value) {
                weekDays.push(key);
            }
            if (key === 'thursday' && value) {
                weekDays.push(key);
            }
            if (key === 'friday' && value) {
                weekDays.push(key);
            }
        }
    }
    return weekDays;
};
exports.default = transformWeekDaysObjectToArray;
